import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService";

const targets = [
  {
    id: 1,
    title: "Month 1 Targets",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+14+Setting+30+Day+Targets+(1).mp4",
  },
  {
    id: 2,
    title: "Month 2 Targets",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+14+Setting+30+Day+Targets+(1).mp4",
  },
  {
    id: 3,
    title: "Month 3 Targets",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+14+Setting+30+Day+Targets+(1).mp4",
  },
];

const Next30 = () => {
  const navigate = useNavigate();
  const textAreaRef = useRef(null);
  const [inputs, setInputs] = useState({});
  const [currentIndex, setCurrentIndex] = useState(() => {
    const savedIndex = localStorage.getItem("currentNext30Index");
    return savedIndex ? JSON.parse(savedIndex) : 0;
  });

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
    localStorage.setItem("currentNext30Index", JSON.stringify(currentIndex));
  }, [currentIndex]);

  const handleInputChange = (e) => {
    setInputs({
      ...inputs,
      [currentIndex]: e.target.value,
    });
  };

  const sendNext30 = async () => {
    const completed_inputs = Object.values(inputs).filter(
      (input) => Array.isArray(input) ? input[0].trim().length > 0 : input.trim().length > 0
    );
    const next30_progress =
      (Number(completed_inputs.length) / Number(targets.length)) * 100;

    const payload = {
      first_month_statement: inputs[0],
      second_month_statement: inputs[1],
      third_month_statement: inputs[2],
      progress: next30_progress,
    };

    try {
      const prevMessagePage = localStorage.getItem("prevMessagePage") === "true";
      if (prevMessagePage) {
        navigate("/message-page")
      } else {
        navigate("/plan-for-success");
      }
      const res = await apiServiceHandler("POST", "api/next30", payload);
    } catch (error) {}
  };

  const handleNext = (e) => {
    e.preventDefault();

    if (!inputs[currentIndex]) {
      toastr.error("Please fill the input field");
      return;
    }

    if (currentIndex === targets.length - 1) {
      sendNext30();
    }
    setCurrentIndex((prevIndex) =>
      prevIndex < targets.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const skipStep = (e) => {
    e.preventDefault();
    if (currentIndex === targets.length - 1) {
      sendNext30();
    }
    setCurrentIndex((prevIndex) =>
      prevIndex < targets.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const handleBack = (e) => {
    e.preventDefault();
    if (currentIndex == 0) {
      navigate("/plan-for-success");
    }
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/next30");
        console.log(res);
        if (res.status && res.data) {
          setInputs({
            0: res.data.first_month_statement || "",
            1: res.data.second_month_statement || "",
            2: Array.isArray(res.data.third_month_statement)
              ? res.data.third_month_statement.join(", ")
              : String(res.data.third_month_statement || ""),
          });
        }
      } catch (error) {
        console.log("Failed to fetch data")
      }
    };

    fetchData();
  }, []);

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="driver-auth-view__container">
            <div className="driver-view">
              <div className="credo-heading">NEXT 30</div>
              <form className="driver-form">
                <div className="driver-view__field">
                  <ReactPlayer
                    url={targets[currentIndex].videoUrl}
                    config={{
                      vimeo: {
                        playerOptions: {
                          title: true,
                          byline: false,
                          portrait: false,
                        },
                      },
                    }}
                    controls={true}
                    width="100%"
                    height="100%"
                  />
                </div>

                <h4 style={{ fontWeight: "lighter", color: "#fff" }}>
                  {targets[currentIndex].title}
                </h4>
                <textarea
                  type="text"
                  className="credo-input"
                  ref={textAreaRef}
                  value={inputs[currentIndex] || ""}
                  onChange={handleInputChange}
                />

                <div
                  style={{ display: "flex", gap: "1rem", alignItems: "center" }}
                >
                  <button
                    type="submit"
                    className="driver-btn"
                    onClick={handleBack}
                    style={
                      targets[currentIndex].isBack
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <span className="driver-button__label">BACK</span>
                  </button>

                  <button
                    type="submit"
                    className="driver-btn"
                    onClick={handleNext}
                  >
                    <span className="driver-button__label">SAVE</span>
                  </button>
                  <div
                    style={{
                      marginTop: "2rem",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={skipStep}
                  >
                    skip
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Next30;
